import React from 'react';


function AboutPage() {
    return (
        <div>
            <h1>OC Local Handyman extensive Experience</h1>
        </div>
    );
}

export default AboutPage;